import clsx from "clsx"

import type { ImageGallerySlice } from "~/api/prismic/types"
import CustomRichText from "~/components/CustomRichText"
import LazyImage from "~/components/LazyImage"

type Props = {
  image: ImageGallerySlice["items"][number]
}

const ImageTile: React.FC<Props> = (props) => {
  const { gallery_image: image, image_captions: captions, credit } = props.image
  const hasCredit = !!credit?.length
  const hasCaptions = !!captions?.length

  return (
    <figure className="!m-0">
      <LazyImage
        key={image.url}
        className="!m-0 w-full object-cover"
        src={image.url}
        alt={image.alt || ""}
        imgixParams={{ q: 70 }}
      />
      {(hasCredit || hasCaptions) && (
        <figcaption className="flex flex-wrap justify-center space-x-2 px-4 pb-2 text-center">
          {hasCredit && (
            <div className="text-xs italic">
              <CustomRichText field={credit} />
            </div>
          )}
          {hasCaptions && (
            <div className={clsx(hasCredit ? "mt-1" : "mt-2")}>
              <CustomRichText field={captions} />
            </div>
          )}
        </figcaption>
      )}
    </figure>
  )
}

export default ImageTile
